import { AccountVestingTypeEnum } from 'constants/vesting'
import { AccountVestingProvider } from 'context/account-vesting-context-provider'
import AccountVestingContent from 'modules/account-vesting/account-vesting-content'

import './style.scss'

const AccountVestingVenture = () => {
  return (
    <AccountVestingProvider type={AccountVestingTypeEnum.ACCOUNT_VESTING_VENTURE}>
      <AccountVestingContent title="Account Vesting Venture" />
    </AccountVestingProvider>
  )
}

export default AccountVestingVenture
